import styled from 'styled-components';
import Chip from '@mui/material/Chip';
import { Theme } from '../Theme';
export const StyledChip = styled(Chip)`
    /* border: ${Theme.borderWidth} solid currentColor !important; */
    border-radius: ${Theme.radius} !important;
    background: ${Theme.colors.dark} !important;
    color: ${Theme.colors.darkText} !important;
    .MuiSvgIcon-root {
        color: ${Theme.colors.darkText} !important;
    }
`;